import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import MainLayout from "./MainLayout";
import { Modal } from "react-bootstrap";
// import { chains } from "../../chains";
import "../../Assets/Css/dashboard.css";
import { Link } from "react-router-dom";
import ZeussToken from "../../../Contract/zeussToken.json";
const Dashboard = () => {
  return (
    <>
      <div className="topbar">
        <h4>
          $TRIBE Contract Address{" "}
          <Link
            target="_blank"
            to={`https://etherscan.io/token/${ZeussToken.address}`}
          >
            {ZeussToken.address}
          </Link>
        </h4>
      </div>
      <div className="dashboardapp">
        <Sidebar />
        <MainLayout />
      </div>
    </>
  );
};

export default Dashboard;
